import {numberFormatter} from "./";

export default (amount: any, decimals = 2, showDecimals = 0): string => {
  if (amount === null || amount === undefined || amount === '') {
    return '';
  }

  // \u00a0 is non breaking space
  return `€\u00a0${numberFormatter(amount, decimals, showDecimals)}`;
};